/**
 * =============================================================================
 * Utilitário: pdfBucketResolver
 *
 * Descrição:
 *   Resolve dinamicamente o bucket do Storage a partir do path de um PDF de
 *   contrato. Convenção do sistema:
 *
 *     - Arquivos enviados pelo usuário no Wizard de Contratos ficam no bucket
 *       `anexos` (mesmo bucket usado por demais anexos do CRM). Estão em:
 *         `{tenantId}/contract-wizard-uploads/{uuid}.pdf`
 *
 *     - PDFs gerados/assinados pelo backend (Edge Functions com service_role)
 *       continuam no bucket legado `contratos`.
 *
 *   Motivação: reaproveitar as políticas RLS já validadas do bucket `anexos`
 *   (usado por deals, notas, documentos, atividades) para uploads iniciados
 *   pelo usuário, evitando duplicar/mexer nas políticas do bucket `contratos`.
 *
 * RELEASE: 2026-07-10 v1.0.0 - Versão inicial.
 * =============================================================================
 */

/** Marcador de path para PDFs enviados no wizard de contratos */
export const WIZARD_UPLOAD_PATH_MARKER = '/contract-wizard-uploads/';

/** Sub-diretório padrão dentro do bucket `anexos` para uploads do wizard */
export const WIZARD_UPLOAD_SUBDIR = 'contract-wizard-uploads';

/** Bucket para uploads iniciados pelo usuário (reusa RLS já validada) */
export const CONTRACT_USER_BUCKET = 'anexos';

/** Bucket legado, escrito por Edge Functions (service_role) */
export const CONTRACT_LEGACY_BUCKET = 'contratos';

/**
 * Retorna o bucket correto para ler/baixar um PDF de contrato,
 * detectando pelo prefixo do path.
 */
export function resolveContractPdfBucket(path: string | null | undefined): string {
  if (!path) return CONTRACT_LEGACY_BUCKET;
  if (path.includes(WIZARD_UPLOAD_PATH_MARKER)) return CONTRACT_USER_BUCKET;
  return CONTRACT_LEGACY_BUCKET;
}

/**
 * Monta o path padronizado dentro do bucket `anexos` para o upload manual do
 * wizard: `{tenantId}/contract-wizard-uploads/{uniqueId}.pdf`.
 */
export function buildWizardUploadPath(tenantId: string, uniqueId: string): string {
  return `${tenantId}/${WIZARD_UPLOAD_SUBDIR}/${uniqueId}.pdf`;
}
